import { render, staticRenderFns } from "./AddAssessmentType.vue?vue&type=template&id=88bc5d1a"
import script from "./AddAssessmentType.vue?vue&type=script&lang=js"
export * from "./AddAssessmentType.vue?vue&type=script&lang=js"
import style0 from "./AddAssessmentType.vue?vue&type=style&index=0&id=88bc5d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports